import React, {useState} from 'react';
import {season} from "../../../models/season";
import {scrollTo} from "../../../service/ToolsService";
import {NavLink} from "react-router-dom";
import {TableLineLoader} from "../../front/loader/TableLineLoader";
import DateService from "../../../service/DateService";
import {DeleteConfirme} from "../DeleteConfirme";
import {ApiService} from "../../../service/ApiService";

type SeasonListProps = {
  seasons: season[],
  loading?: boolean,
  refresh: () => void
}

export const SeasonList = ({seasons, loading, refresh}: SeasonListProps) => {
  const [del, setDel] = useState(undefined as undefined | season);

  const deleteSeason = async (season: season) => {
    await ApiService.delete(`/season/${season.seasonId}`);
    refresh();
  };

  return (
    <>
      <table className="table table-responsive table-hover border">
        <thead>
        <tr className="table-primary">
          <th>Nom</th>
          <th className="text-center w150px">Actif</th>
          <th className="text-center w150px">Randonnée</th>
          <th className="text-center w150px">Course</th>
          <th className="text-center w150px">Modification</th>
          <th className="w200px"></th>
        </tr>
        </thead>
        <tbody>
        {loading && (
          <tr>
            <td colSpan={6} className="pt-4 pb-4 ps-5 pe-5">
              <TableLineLoader/>
            </td>
          </tr>
        )}

        {!loading && seasons.map((season: season, i: number) => (
          <tr key={i} className={season.enabled ? 'table-success' : ''}>
            <td>{season.label}</td>
            <td className="text-center">{season.enabled && (<i className="fa-solid fa-eye"/>)}</td>
            <td className="text-center">
              {season.races ? season.races.filter(r => ! r.ranking).length : '~'}
            </td>
            <td className="text-center">
              {season.races ? season.races.filter(r => r.ranking).length : '~'}
            </td>
            <td className="text-center">
              {DateService
                .toLocaleString(season.updatedAt ?? season.createdAt, {day: '2-digit', month: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false})
              }
            </td>
            <td className="text-end">
              <NavLink to={`/admin/season/show/${season.seasonId}`} onClick={scrollTo} className="btn btn-xs btn-primary me-1">
                <i className="fa-solid fa-pencil me-1"/> modifier
              </NavLink>
              <button className="btn btn-xs btn-danger" onClick={() => setDel(season)}><i className="fa-solid fa-xmark me-1"/>supprimer</button>
            </td>
          </tr>
        ))}
        </tbody>
      </table>

      {del && (
        <DeleteConfirme confirme={(c: boolean) => {
          if (c) {
            deleteSeason(del);
          }

          setDel(undefined);
        }}/>
      )}
    </>
  )
}
